var React = require('react');

function SearchIcon (props) {
    return React.createElement("svg",props,[React.createElement("rect",{"width":"45","height":"45","rx":"4","fill":"#0000FF","key":0}),React.createElement("path",{"d":"M29.7358 27.9297C30.9922 26.1672 31.7436 24.0023 31.7436 21.6553C31.7436 15.7802 27.0906 11 21.3718 11C15.653 11 11 15.7802 11 21.6553C11 27.5304 15.653 32.3106 21.3718 32.3106C23.6564 32.3106 25.7639 31.5385 27.4796 30.2478L31.7436 35L34 32.682L29.7358 27.9297ZM21.3718 29.032C17.4123 29.032 14.1914 25.7231 14.1914 21.6553C14.1914 17.5875 17.4123 14.2786 21.3718 14.2786C25.3314 14.2786 28.5523 17.5875 28.5523 21.6553C28.5523 25.7231 25.3314 29.032 21.3718 29.032Z","fill":"white","key":1})]);
}

SearchIcon.defaultProps = {"width":"45","height":"45","viewBox":"0 0 45 45","fill":"none"};

module.exports = SearchIcon;

SearchIcon.default = SearchIcon;
